import { switchCurrentBranch } from "@store/slice/current-slice";
import { setLogoutForPosPaySettings } from "@store/slice/Pos-pay-settings-slice";
import { setLogoutForSubscribe } from "@store/slice/subscribe-slice";
import { setLogout, setPermissions } from "@store/slice/user-slice";
import { clearLegacyPimsDefaultPath } from "../../pages/Pims/pimsDefaultPath";
import { clearLegacyAppointmentDoctorPreferences } from "../../pages/Appointment/appointmentDoctorFilter";
import { clearMyAccountPermissionsSnapshot } from "@helpers/myAccountPermissionsSnapshot";

// authActions.js
export const handleLogout = (dispatch) => {
    localStorage.removeItem('authToken');
    dispatch(setLogout());
    localStorage.removeItem("revxToken");
    localStorage.removeItem("revxId");
    localStorage.removeItem("permissions");
    localStorage.removeItem("eternalHelper");
    localStorage.removeItem("eternalEmployeeInfo");
    localStorage.removeItem("features");
    clearMyAccountPermissionsSnapshot();
    clearLegacyPimsDefaultPath();
    clearLegacyAppointmentDoctorPreferences();
    dispatch(setLogoutForSubscribe());
    dispatch(setLogoutForPosPaySettings());
    dispatch(switchCurrentBranch({ branchId: 0, branchInfo: {} }));
    dispatch(setPermissions({ permissions: [] }));
};
